import React, { useState, useEffect, useRef } from "react";
import { useAuth } from "../../AuthContext";
import Axios from 'axios';
import { useNavigate, useParams } from "react-router-dom";
import { MdLocationOn } from "react-icons/md";
import FillerImage from "../../assets/filler-image.jpg";
import Navbar from "../../components/Navbar.js";
import Stars from "../../components/Stars.js"


function UpdateDetail() {
    console.log("Update Detail View component rendered");
    // const sampleId = '65b4a8b389f976a7e2917fb0';
    // const sampleId = '65a7c037db6ed260a9bbc9c9';
    const { loggedIn, user } = useAuth();
    console.log(user.id)    
    const sampleId = useParams().data;
    console.log(sampleId)

    const navigate = useNavigate();
    const [LogoImage, setLogoImage] = useState(FillerImage);
    const [MainImage,setMainImage] = useState(FillerImage);
    const [BuildingName,setBuildingName] = useState();
    const [CollegeName, setCollegeName] = useState();
    const [BathroomName, setBathroomName] = useState();
    const [BathroomFloor, setBathroomFloor] = useState();
    const [BathroomAddress, setBathroomAddress] = useState();
    const [BathroomRating, setBathroomRating] = useState(0);
    const [BathroomReviewCount, setBathroomReviewCount] = useState(0);
    const [BathroomQualities, setBathroomQualities] = useState([])
    const [inputDetails, setInputDetails] = useState([])
    const [detailsTable, setDetailsTable] = useState([]);
    // var inputDetails;
    // console.log(detailsTable)


    const [data, setData] = useState([]);
    useEffect(() => {
        console.log("Fetching bathroom details...");
        const fetchData = async () => {
          try {
            const res = await fetch(`https://uplbidet-api.vercel.app/api/cr/${sampleId}`);
            if (!res.ok) {
              throw new Error("An error has occured.");
            }
    
            const jsonData = await res.json();
            setData(jsonData);

            // Fetch logo image after data is fetched
            (async () => {
                try {
                    if (jsonData) {
                        // const res = await import(`../../assets/colleges/${jsonData.college.toUpperCase()}.png`);
                        setLogoImage((await import(`../../assets/colleges/${jsonData.college.toUpperCase()}.png`)).default);
                        setMainImage(jsonData.interior_photo)
                        setBuildingName(jsonData?.building?.toUpperCase())
                        setCollegeName(jsonData?.college?.toUpperCase())    
                        setBathroomName(jsonData.name)  
                        setBathroomFloor(jsonData.floor)
                        setBathroomAddress(jsonData.description)
                        setBathroomRating(jsonData.average_rating)
                        setBathroomQualities(jsonData.tags)

                        const initInputDetails = [
                            { attribute: 'BIDET', classification: jsonData.bidet },
                            { attribute: 'TISSUE PAPER', classification: jsonData.tissue_paper },
                            { attribute: 'SOAP', classification: jsonData.soap },
                            { attribute: 'HAND DRYER', classification: jsonData.hand_dryer },
                            { attribute: 'CLASS', classification: jsonData.type },
                        ];
                        
                        // console.log(inputDetails);
                        setInputDetails(initInputDetails)
                        setDetailsTable(initInputDetails);
                }
                } catch (error) {
                    console.error("Error fetching logo image: ", error);
                    // Handle the error or set a default image in case of failure
                    setLogoImage(FillerImage);
                }
            })();



          } catch (error) {
            console.error("Error fetching data: ", error);
          }
        };
            fetchData();
        }, []
    );

    console.log(data)

    const [reviews, setReviews] = useState([]);
    useEffect(() => {
        console.log("Fetching reviews...");
        const fetchReviews = async () => {
          try {
            const res = await fetch(`https://uplbidet-api.vercel.app/api/reviews/cr/${sampleId}`);
            if (!res.ok) {
              throw new Error("An error has occured.");
            }
    
            const jsonReviews = await res.json();
            const reviewPromise =  jsonReviews.map(async (review) =>  {
                        const res = await fetch(`https://uplbidet-api.vercel.app/api/users/${review.user_id}`);
                        const user = await res.json();
                        console.log(user._id,user.username,"This is a trial");
                        review.userName = user.username;
                        review.logo = user.user_image;
                    });

            await Promise.all(reviewPromise);
            console.log(jsonReviews,"Add")
            setReviews(jsonReviews);
            setBathroomReviewCount(jsonReviews.length)
          } catch (error) {
            console.error("Error fetching reviews: ", error);
          }
        };
            fetchReviews();
        }, []
    );

    console.log(reviews)

    const getOrdinalNumber = (number) => {
        const suffixes = ["th", "st", "nd", "rd"];
        const v = number % 100;
        return number + (suffixes[(v - 20) % 10] || suffixes[v] || suffixes[0]);
      };

    const handleCheckboxChange = (index) => {
        setDetailsTable((prevDetails) => {
            const newDetailsTable = [...prevDetails];
            newDetailsTable[index] = {
                ...newDetailsTable[index],
                classification: !newDetailsTable[index].classification,
              };
            return newDetailsTable;
        });
    };

    const handleSelectChange = (index, value) => {
        setDetailsTable((prevDetails) => {
          const newDetailsTable = [...prevDetails];
          newDetailsTable[index] = {
            ...newDetailsTable[index],
            classification: value,
          };
          return newDetailsTable;
        });
      };
    
    const handlePostButtonClick = async () => {
        alert(`Details successfully updated!`)
        
        const bidet = detailsTable.find((details) => details.attribute === 'BIDET').classification;
        const tissue_paper = detailsTable.find((details) => details.attribute === 'TISSUE PAPER').classification;
        const soap = detailsTable.find((details) => details.attribute === 'SOAP').classification;
        const hand_dryer = detailsTable.find((details) => details.attribute === 'HAND DRYER').classification
        const type = detailsTable.find((details) => details.attribute === 'CLASS').classification


        const updatedFields = {
            // Add the fields you want to update and their new values
            bidet: bidet,
            tissue_paper: tissue_paper,
            soap: soap,
            hand_dryer: hand_dryer,
            type: type
            // ... add more fields as needed
        };
        
        try {
            console.log(sampleId)
            console.log("Axios Request:", {
                method: "PATCH",
                url: `https://uplbidet-api.vercel.app/api/cr/${sampleId}`,
                data: updatedFields,
            });
            const response = await Axios.put(`https://uplbidet-api.vercel.app/api/cr/${sampleId}`, updatedFields);
            console.log(response)
        
            if (response.status === 200) {
                console.log("Restroom updated successfully:", response.data);
                setInputDetails([
                    { attribute: 'BIDET', classification: response.data.bidet },
                    { attribute: 'TISSUE PAPER', classification: response.data.tissue_paper },
                    { attribute: 'SOAP', classification: response.data.soap },
                    { attribute: 'HAND DRYER', classification: response.data.hand_dryer },
                    { attribute: 'CLASS', classification: response.data.type },
                    // ... add more fields as needed
                ]);
                window.history.back();
            } else {
                console.log("Failed to update restroom:", response.status, response.data);
            }
        } catch (error) {
            console.error("Error updating restroom:", error.response);
            // Handle other potential errors
        }

    };
    

    const [isButtonDisabled, setButtonDisabled] = useState(true);

    useEffect(() => {
        setButtonDisabled(inputDetails === detailsTable);
    }, [inputDetails, detailsTable]);


    const handleDiscardButtonClick = () => {
        const shouldReturn = window.confirm('Do you want to discard changes and return to the previous window?');

        if (shouldReturn) {
          window.history.back();
        }
    }                

  return (
    <>
        <Navbar />
        <div className="main-content">
            <div className="workable-area">
                <div className="portion-container">
                    <div className="image-container">
                        <img
                            src={MainImage} 
                            width={300}
                            height={350}
                            padding={10}
                            alt="Image of a bathroom"
                            style={{
                                boxShadow: '0 4px 8px rgba(0, 0, 0, 0.5)'
                            }}
                        />

                    </div>

                    <div className="horizontal-flex" >
                        
                        <img 
                            className="logo-style"
                            src={LogoImage}
                            width={75}
                            height={75}
                            alt="This is a logo"
                        />

                        <div className="bathroom-info"> 
                        <span style={{
                            fontFamily: 'Roboto, sans-serif',
                            fontSize: 40,
                        }}>
                            {BuildingName}
                        </span>
                            <span style={{
                                fontFamily: 'Roboto, sans-serif',
                                fontSize: 25,
                            }}>
                                {CollegeName}
                            </span>
                            <span>
                                <i>
                                    {BathroomName}, {getOrdinalNumber(BathroomFloor)} Floor, {BathroomAddress}
                                </i>
                            </span>
                                <span className="new-vertical-flex" style={{marginTop: '5px',}}>
                                    <div className="category-widget">
                                        <div>
                                            RATING:  

                                        </div>
                                        <div style={{color:'gray', paddingLeft:'5px'}}>
                                            <Stars averageRating={BathroomRating} /> 
                                            ({BathroomRating}/5 stars)
                                        </div>
                                    </div>
                                    <div className="category-widget">
                                        <div>
                                            NUMBER OF REVIEWS:

                                        </div>
                                        <div style={{color:'gray', paddingLeft:'25px'}}>
                                            {BathroomReviewCount}
                                        </div>
                                    </div>
                                </span>
                                {BathroomQualities && BathroomQualities.length > 0 && 
                                (
                                    <span className="row-container" style={{marginTop: '5px',}}>
                                        {BathroomQualities.map((item, index) => (
                                            <button className="oval-button">
                                                <div className="text-padding">
                                                    {`${item.tag} (${item.users.length})`}
                                                </div>
                                            </button>
                                        ))}
                                        
                                        {/* <button className="oval-button" onClick={() => handleTagButtonClick(-1)}>
                                            <div className="text-padding">
                                                +
                                            </div>
                                        </button> */}
                                    </span> 
                                )
                                }
                            

                            <span className="horizontal-flex" style={{marginTop: '10px', justifyContent: 'space-between', height: '100%'}}>
                                
                                <div className="new-vertical-flex" style={{justifyContent: 'space-evenly', width: '100%'}}>
                                    <div>DETAILS:</div>
                                    <table style={{ width: '100%' }}>
                                        <tbody>
                                        {inputDetails?.map((detail, index) => (
                                            <tr key={index} style={{ justifyContent:'space-between' }}>
                                                <td>{`• ${detail.attribute}:     `}</td>
                                                <td style={{ paddingLeft: '5px', color: 'gray'}}>{
                                                    (detail.classification === true ? 'YES' : 
                                                        (detail.classification === false ? 'NO': 
                                                            (detail.classification === 'pwd'? 'GENDER NEUTRAL AND PWD(s)' :
                                                            detail?.classification?.toUpperCase())))}
                                                </td>
                                            </tr>
                                        ))}
                                        </tbody>
                                    </table>
                                </div>
                            </span>
                        </div>
                    </div>
                    <span className="new-vertical-flex" style={{maxHeight: '100vw', justifyContent: "space-between"}}>
                        <MdLocationOn size={90} color="maroon" />
                    </span>
                </div>

                <hr />

                <div className="portion-container">
                    {/* Bottom Portion */}
                    <div className="new-vertical-flex" style={{ width:'100%' }}>
                            <div className="new-vertical-flex" style={{justifyContent: 'space-between'}}>
                                <div className="horizontal-flex" style={{justifyContent: 'space-around'}}>
                                    <div>
                                        <div 
                                            style={{
                                            fontFamily: 'Roboto, sans-serif',
                                            fontSize: 40,
                                        }}>
                                            Request an update of the details
                                        </div>
                                            <div>
                                                    <p>Are these options available?</p>
                                                <table>
                                                    <tbody>
                                                        {detailsTable.map((details, index) => (
                                                            <tr key={index} style={{ justifyContent: 'space-between' }}>
                                                            <td>{`• ${details.attribute}: `}</td>
                                                            {/* <td style={{ paddingLeft: '5px', color: 'gray' }}>{details.classification}</td> */}
                                                            <td>
                                                                {details.attribute === 'CLASS' ? (
                                                                <select value={details.classification} onChange={(e) => handleSelectChange(index, e.target.value)}>
                                                                    <option value="">-- Select --</option>
                                                                    <option value="male">Male only</option>
                                                                    <option value="female">Female only</option>
                                                                    <option value="gender-neutral">Gender neutral</option>
                                                                    <option value="pwd">Gender neutral and PWD</option>
                                                                </select>
                                                                ) : (
                                                                <input
                                                                    type="checkbox"
                                                                    checked={details.classification}
                                                                    onChange={
                                                                        () => handleCheckboxChange(index)
                                                                    }
                                                                />
                                                                )}
                                                            </td>
                                                            </tr>
                                                        ))}
                                                    </tbody>
                                                </table>
                                            </div>
                                    </div>
                                    <div className="new-vertical-flex">
                                        <span className="row-container">
                                            <button className="rectangular-red-button" onClick={handleDiscardButtonClick} disabled={isButtonDisabled}>
                                                <div className="text-padding">
                                                DISCARD
                                                </div>
                                            </button>
                                            <button className="rectangular-red-button" onClick={handlePostButtonClick} disabled={isButtonDisabled}>
                                                <div className="text-padding">
                                                DONE
                                                </div>
                                            </button>

                                        </span>

                                    </div>
                                    
                                </div>
                            </div>
                    </div>
                </div>
            </div>
        </div>
    </>
    );
}

export default UpdateDetail;